import React, { useEffect, useState } from 'react';
import { Header, Footer, LeftMenu } from '../commons/components';
import { Content } from './components';
import { usePageSettingHeaderStore } from '../commons/stores';
import { getAllThemes, getAllCustomers, getAllEmployees } from './actions';

import { isAuth } from '../auth/actions';
import { Redirect } from 'react-router';

export default function Home() {
  const [statePageSettingHeader] = usePageSettingHeaderStore();

  const [themes, setThemes] = useState([]);
  const [customers, setCustomers] = useState([]);
  const [employees, setEmployees] = useState([]);

  useEffect(() => {
    document.title = `Dashboard - Ubaform Admin`;
    loadThemes();
    loadCustomers();
    loadEmployees();
  }, []);

  const loadThemes = () => {
    getAllThemes().then((data) => {
      if (data.error) {
        console.log(data.error);
      } else {
        console.log('All Themes', data);
        setThemes(data);
      }
    });
  };
  const loadCustomers = () => {
    getAllCustomers().then((data) => {
    
      if (data.error) {
        console.log(data.error);
      } else {
        console.log('All Customer', data);
        setCustomers(data);
      }
    });
  };
  const loadEmployees = () => {
    getAllEmployees().then((data) => {
      if (data.error) {
        console.log(data.error);
      } else {
        console.log('All Employees', data);
        setEmployees(data);
      }
    });
  };

  let contentUi = <div className='loader-block' />;
  // if (!state.isLoading) {
  contentUi = (
    <React.Fragment>
      <Content themes={themes} customers={customers} employees={employees} />
    </React.Fragment>
  );

  return (
    <>
      {isAuth() ? (
        <div className='App'>
          <Header />
          {statePageSettingHeader.leftMenu ? <LeftMenu /> : null}

          <main className='workspace'>
            {/* <Content /> */}

            {contentUi}

            <Footer />
          </main>
        </div>
        ) : (
          <Redirect to='/auth' />
      )}
    </>
  );
}
